import { useSession } from "Context/userAuthContext";
import { logOut, publishProfile } from "Util/firebaseHelper";
import { Formik, Form } from "formik";
import { profileValidationSchema } from "Model/Profile";
import { editSellerProfile } from "Redux/actionCreators";
import { useAppDispatch } from "Redux/hooks";

import {
  Button,
  Box,
  TextField,
  Typography,
  InputAdornment,
  Stack,
  Divider,
} from "@mui/material";
import { InfoBox, CardStyle } from "Components/AllComponents";
import { useNavigate } from "react-router-dom";

interface OnboardingProps {
  onComplete?: () => void;
  isModal?: boolean;
}

const Onboarding: React.FC<OnboardingProps> = ({
  onComplete,
  isModal = false,
}) => {
  const { user, sellerProfile } = useSession();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <Stack alignItems="center">
      <Box sx={{ maxWidth: 600, width: "100%" }}>
        <Formik
          validateOnChange={false}
          initialValues={sellerProfile}
          enableReinitialize={true}
          validationSchema={profileValidationSchema(
            sellerProfile.username.toLowerCase()
          )}
          onSubmit={(values, actions) => {
            publishProfile(
              {
                ...values,
                username: values.username.toLowerCase(),
                links: sellerProfile.links,
                uid: user?.uid || "",
                sellerEmail: user?.email || "",
              },
              user?.uid || ""
            );
            actions.resetForm({
              values: values,
            });
            dispatch(editSellerProfile(values));

            if (isModal && onComplete) {
              onComplete();
            } else {
              navigate("/admin/home");
            }
          }}
        >
          {(props) => (
            <Form>
              <Stack>
                <Typography color="text.primary" variant="h4" mb={1}>
                  Claim your link
                </Typography>
                <Typography color="text.primary" variant="body1">
                  After setting up your link, you'll be able to create forms,
                  manage requests and orders, and set up presales.
                </Typography>

                <TextField
                  fullWidth
                  margin="normal"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography>flowlylink.com/</Typography>
                      </InputAdornment>
                    ),
                  }}
                  required
                  id="username"
                  name="username"
                  placeholder="username"
                  value={props.values.username.toLowerCase()}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  error={
                    props.touched.username && Boolean(props.errors.username)
                  }
                  helperText={props.touched.username && props.errors.username}
                />

                <Stack alignItems="center" mt={1} mb={2}>
                  <Button
                    size="large"
                    type="submit"
                    variant="contained"
                    disabled={!user}
                    sx={{ width: "fit-content" }}
                  >
                    Claim my link
                  </Button>
                </Stack>

                <Divider sx={{ mt: 2, mb: 2 }} />

                <Stack direction="row" alignItems="center">
                  <Typography variant="body1" flex={1}>
                    {user?.email}
                  </Typography>
                  <Button
                    onClick={() => {
                      logOut();
                      window.location.reload();
                    }}
                    sx={{ color: "text.secondary" }}
                  >
                    Switch account
                  </Button>
                </Stack>
              </Stack>
            </Form>
          )}
        </Formik>
      </Box>
    </Stack>
  );
};

export default Onboarding;
